import { FunctionComponent } from 'react';
import GenericIcons from '../../../components/generics/GenericIcons';
import { useNavigate } from 'react-router-dom';
import '../../../css/PublicWhatWeDoPage.css';

const Component05: FunctionComponent = () => {
  const navigate = useNavigate();
  const goToLoginPage = () => navigate('/public/login');

  return (
    <div className='public-what-we-do-page-component-five-container vdr-wwd-doc'>
      <div className='vdr-section-head vdr-wwd-section-head'>
        <h2 className='public-what-we-do-page-title'>Evaluación de conexión de proyectos</h2>
        <small>Norma técnica</small>
      </div>
      <p className='public-what-we-do-page-text'>
        Utilizando una metodología alineada con la normativa técnica vigente (NTCO), esta
        herramienta permite evaluar la conexión de un proyecto PMGD o EG en un nodo del alimentador,
        proporcionando resultados preliminares para determinar la viabilidad técnica de nuevos
        proyectos de generación distribuida.
      </p>
      <figure style={{ margin: 0 }} className='public-what-we-do-page-component-img-container'>
        <GenericIcons
          icon='connection_evaluation'
          imageStyle={{
            width: '70%',
            height: 'auto'
          }}
        />
        <figcaption className='public-what-we-do-page-component-img-caption'>
          Figura 8: Procedimiento de estudios para evaluación de conexión
        </figcaption>
      </figure>
      <p className='public-what-we-do-page-text'>
        La metodología de evaluación de conexión implementada inicialmente calcula la capacidad
        instalada permitida (<b>CIP</b> o <b>ICE</b>) y la inyección de excedente permitida (
        <b>IEP</b> o <b>CCE</b>), parámetros definidos en la norma técnica de conexión de proyectos
        PMGD y en la norma técnica de conexión de proyectos EG que permiten determinar si un
        proyecto puede conectarse de manera expeditiva. En el caso de que no sea así, se continúa
        con una serie de estudios técnicos detallados que permiten definir si el proyecto en
        evaluación causa impacto significativo en los voltajes, corrientes, congestiones,
        cortocircuitos y pérdidas.
      </p>
      <p className='public-what-we-do-page-text'>
        Los estudios técnicos que la herramienta es capaz de ejecutar son los siguientes:
      </p>
      <ul className='public-what-we-do-page-list'>
        <li>
          <b>Estudio de flujo de potencia:</b> Mediante este estudio se verifica que la conexión del
          PMGD o EG, considerando sus inyecciones de potencia activa y reactiva, cumpla con las
          exigencias técnicas de congestión y tensión. Por cada flujo de potencia se evalúa:
          <ul>
            <li>Niveles de carga en líneas y transformadores</li>
            <li>Tensiones en el alimentador</li>
            <li>Inversión de flujo en la cabecera</li>
            <li>Inversión de flujo y congestión en la subestación</li>
            <li>Congestión en transmisión zonal</li>
          </ul>
        </li>
        <li>
          <b>Estudio de cortocircuitos:</b> Mediante este estudio se verifica que los niveles de
          cortocircuito con el PMGD no superen el 85% de capacidad de ruptura de los elementos de
          desconexión. Se evalúan cortocircuitos monofásicos, trifásicos, bifásicos a tierra y
          bifásicos sin contacto con tierra. Los puntos del alimentador donde se evalúan estos
          cortocircuitos son:
          <ul>
            <li>Cabecera del alimentador</li>
            <li>Punto de conexión</li>
            <li>Aguas abajo de las protecciones RI de los PMGD con ICC vigente</li>
            <li>Reconectadores de línea en el alimentador</li>
          </ul>
        </li>
        <li>
          <b>Estudio de pérdidas eléctricas:</b> Mediante este estudio se verifica que el impacto
          del PMGD en el incremento de las pérdidas eléctricas anuales del alimentador no superen un
          10% respecto al caso basal sin PMGD conectado. Es posible reducir las horas evaluadas
          utilizando técnicas que incluyan al menos 20 días representativos por año, con sus
          probabilidades de ocurrencia, lo que reduce el tiempo de cómputo requerido para ejecutar
          un estudio de conexión. Este estudio únicamente es ejecutado para evaluación de conexión
          de PMGD, no para proyectos EG.
        </li>
      </ul>
      <p className='public-what-we-do-page-text'>
        El único estudio que es dejado de lado respecto a lo que indica la norma técnica de conexión
        y operación (NTCO) es el estudio de coordinación de protecciones, esto se debe a las
        limitaciones prácticas de acceso a información de ajustes de equipos y las necesidades
        particulares para la ejecución de este estudio para cada uno de los proyectos a evaluar. Con
        estos resultados, el usuario tiene a su disposición información preliminar confiable sobre
        la viabilidad técnica de su proyecto, que podría ser de utilidad para adaptar su propuesta
        previa a una evaluación oficial.
      </p>
      <div className='public-what-we-do-page-btn-container'>
        <button className='primary-button-style public-what-we-do-page-btn' onClick={goToLoginPage}>
          Explorar herramienta
          <span aria-hidden='true'>→</span>
        </button>
      </div>
    </div>
  );
};

export default Component05;
